import React, { useEffect, useState } from "react";

import { Container, ContentHeader, List, TableColumns } from "./styles";

import HistoryListItem from "../HistoryListItem/HistoryListItem";
import ModalViewClients from "../ModalViewClients/ModalViewClients";

import Modal from "react-modal";
import { FiSearch } from "react-icons/fi";
import { Menu } from "@mui/material";
import {
  CancelButton,
  ClearSearch,
  SearchBar,
  SearchButton,
  SearchContainer,
} from "@components/DataTable/styles";
import { AiOutlineCloseCircle } from "react-icons/ai";
import ModalConfirm from "@components/Modal/ModalConfirm/ModalConfirm";
import { ImportHistory } from "@domain/models/ImportHistory";
import showToast from "@helpers/showToast";
import { GetClientImportationsUseCase, UndoImportClientsUseCase } from "@useCases/index";
import { HttpImportRepository } from "@data/repositories/index";
import { api } from "@data/api";
import useAlgolia from "@hooks/useAlgolia";
import { HttpClientImportationsRepository } from "@data/repositories/Http/HttpClientImportationsRepository";
import { arrayHelper } from "@helpers/array";
import { ImportJob } from "@domain/models/ImportJob";

type Props = {
  importHistory: ImportHistory[];
  onUndoImport: (job: ImportJob) => void;
};

export default function HistoryList({ importHistory, onUndoImport }: Props) {
  const { algoliaSearchResult } = useAlgolia();

  const [modalVisible, setModalVisible] = useState(false);
  const [modalUndo, setModalUndo] = useState(false);

  const [modalLoading, setModalLoading] = useState(false);

  const [selectedHistory, setSelectedHistory] = useState<ImportHistory>();

  const [filteredHistory, setFilteredHistory] = useState<ImportHistory[]>([]);

  const [search, setSearch] = useState("");
  const [draftSearch, setDraftSearch] = useState("");
  const [searchBar, setSearchBar] = useState(null);
  const openSearch = Boolean(searchBar);

  useEffect(() => {
    if (search) {
      searchHistoryList();
    }
  }, [search]);

  const handleView = async (data) => {
    setSelectedHistory(data);
    setModalVisible(true);
  };

  const searchHistoryList = () => {
    algoliaSearchResult(search).then((clients) => {
      if (clients.length > 0) {
        const client = clients[0];

        const useCase = new GetClientImportationsUseCase(new HttpClientImportationsRepository(api));

        useCase.execute(client.id).then((clientImportations) => {
          if (clientImportations.length > 0) {
            const importationsIds = arrayHelper.reduceToSimple(clientImportations, "id");

            const newHistory = importHistory.filter((x) => importationsIds.includes(x.id));
            setFilteredHistory(newHistory);
          }
        });
      }
    });
  };

  const clearOperation = () => {
    setModalLoading(false);
    setModalUndo(false);
    setSelectedHistory(null);
  };

  const clearSearch = () => {
    setSearch("");
    setDraftSearch("");
  };

  const handleSearch = () => {
    setSearchBar(null);
    setSearch(draftSearch);
  };

  const handleUndoImport = async (item: ImportHistory) => {
    setModalLoading(true);
    if (item.importedClients > 0) {
      const useCase = new UndoImportClientsUseCase(new HttpImportRepository(api));

      useCase
        .execute(item.id)
        .then((job) => {
          onUndoImport(job);
        })
        .finally(() => {
          clearOperation();
          setModalLoading(false);
        });
    } else {
      showToast("Nenhum cliente a ser revertido", "error");
      clearOperation();
    }
  };

  const listData = search ? filteredHistory : importHistory;

  return (
    <Container>
      <ContentHeader>
        <h4>Histórico de importações</h4>

        <div>
          <FiSearch
            onClick={(event) => {
              setSearchBar(event.currentTarget);
            }}
            size={20}
            cursor="pointer"
            color="var(--grey2)"
          />
          <ClearSearch>
            {draftSearch && (
              <>
                {draftSearch}
                <AiOutlineCloseCircle cursor="pointer" onClick={() => clearSearch()} />
              </>
            )}
          </ClearSearch>
        </div>
      </ContentHeader>
      <TableColumns>
        <h3>Administrador</h3>
        <h3>Status</h3>
        <h3>Data da importação</h3>
        <h3>Importados</h3>
        <h3>Não importados</h3>
        <h3>Total</h3>
        <h3>Ações</h3>
      </TableColumns>
      <List>
        {listData &&
          listData.map((item, index) => (
            <HistoryListItem
              key={index}
              data={item}
              onView={() => handleView(item)}
              onUndo={() => {
                setSelectedHistory(item);
                setModalUndo(true);
              }}
            />
          ))}
      </List>
      <Modal
        isOpen={modalVisible}
        onRequestClose={() => {
          setModalVisible(false);
        }}
        overlayClassName="modal-overlay"
        className="modal-content-auto-width"
        contentLabel="Example Modal"
      >
        <ModalViewClients history={selectedHistory} onClose={() => setModalVisible(false)} />
      </Modal>

      <Modal
        isOpen={modalUndo}
        onRequestClose={() => {
          setModalUndo(false);
        }}
        overlayClassName="modal-overlay"
        className="modal-content-auto-width"
        contentLabel="Example Modal"
      >
        <ModalConfirm
          loading={modalLoading}
          text="Tem certeza que deseja desfazer a importação de clientes?"
          option="Desfazer importação"
          onCancel={() => setModalUndo(false)}
          onConfirm={() => handleUndoImport(selectedHistory)}
        />
      </Modal>

      <Menu
        id="basic-menu"
        anchorEl={searchBar}
        open={openSearch}
        onClose={() => {
          setSearchBar(null);
        }}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        PaperProps={{
          style: {
            width: 600,
            height: 40,
            maxHeight: 40,
            borderRadius: 20,
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            overflow: "hidden",
          },
        }}
      >
        <SearchContainer
          onSubmit={(e) => {
            e.preventDefault();
            handleSearch();
          }}
        >
          <FiSearch size={18} cursor="pointer" color="#626F87" strokeWidth="3" />
          <p>&#8288;</p>
          <SearchBar>
            <input
              name="draftSearch"
              onChange={(event) => setDraftSearch(event.target.value)}
              value={draftSearch}
              placeholder="Buscar..."
              autoFocus={true}
            />
          </SearchBar>
          <CancelButton onClick={() => setSearchBar(null)}>Cancelar</CancelButton>
          <SearchButton onClick={() => handleSearch()}>Buscar</SearchButton>
        </SearchContainer>
      </Menu>
    </Container>
  );
}
